import { Typography } from '@mui/material';
import Avatar from 'further-ui/components/Avatar';
import { Column, Row } from 'further-ui/components/Layout';

type Props = {
  name: string;
  subtext?: string;
  avatarSize?: 'md' | 'lg' | 'xl';
};

const AvatarWithName: React.FC<Props> = ({
  name,
  subtext,
  avatarSize = 'md',
}) => {
  return (
    <Row spacing="xs" centered>
      <Avatar size={avatarSize} text={name} color="random" />
      <Column>
        <Typography variant="inherit">{name}</Typography>
        {subtext ? <Typography variant="body2">{subtext}</Typography> : null}
      </Column>
    </Row>
  );
};

export default AvatarWithName;
